import { ArrowSoftRight } from 'src/shared/design-system/Icon';
import styled from 'styled-components';
import { BorderRadius, Colors, Font, Spacing } from 'web-common/src/shared/styles';

export const Card = styled.div`
  width: 160px;
  min-width: 160px;
  height: 368px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: ${Spacing.SINGLE_QUARTER};

  border-radius: ${BorderRadius.M};
`;

const ArrowContainer = styled.div`
  width: 40px;
  height: 40px;
  border: 1.25px solid ${Colors.GRAY_LITE_20};
  border-radius: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;

const Text = styled.span`
  font-weight: ${Font.Weight.BOLD};
  font-size: ${Font.Size.L};

  text-align: center;

  color: ${Colors.GRAY_DARK_30};
`;

interface SeeAllButtonProps {
  onClick: () => void;
  className?: string;
}

export const SeeAllCard = ({ onClick, className }: SeeAllButtonProps): JSX.Element => (
  <Card onClick={onClick} className={className}>
    <ArrowContainer>
      <ArrowSoftRight color={Colors.RADISH} />
    </ArrowContainer>
    <Text>See all</Text>
  </Card>
);
